import React, { useState, useEffect } from 'react'
import { Button, Typography } from '@mui/material';
import { Modal } from 'react-bootstrap'
import UpdateForm from './UpdateForm'

export default function VonHubInterface() {

  const [lgShow, setLgShow] = useState(false);
  const [accessType, setAccessType] = useState('');

  //API call
  useEffect(() => {

    const loggedInUser = sessionStorage.getItem("user_token");
    const foundUser = JSON.parse(loggedInUser);

    if (foundUser.role === 'SuperAdmin') {

      setAccessType('Edit');

    }
    else {

      setAccessType(foundUser.access['VonHubInterface_Access Specifier']);
    }

  }, []);
  return (
    <>
      <div className="row my-3 ">
        {/* <div className="col-md-6">
          <Typography className="mx-3" variant='h6' sx={{ pb: 3 }}>
            Call Center - Interface {accessType === 'View' ? " / View Only Mode" : ""}
          </Typography>
        </div> */}
        <div className="col-md-6 d-flex justify-content-end"   >

          {/* <button type="button" className="btn btn-danger" onClick={() => setLgShow(true)} style={{ height: "40px" }}  >Help</button> */}
          

        </div>
      </div>


      {accessType === 'View' ? <UpdateForm accessType={accessType} /> : <UpdateForm />}

    </>
  );
}
